
import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { ChangelogBox } from "../../components/changelog/ChangelogBox";
import { useAppSelector, VRIAppStateType } from "../../core";
import { shallowEqual } from "react-redux";
import { Link, useLocation } from 'react-router-dom';
import { AppConstants, AppRouteUi, PaginationSettings } from "../../configs";
import { AssetSvg } from "../../assets";
import { useFunctionalityAuth } from "../../pages/hooks";
import { useFunctionalityPagedChangelog, useFunctionalityChangelog } from '../hooks/functionalityChangelog';
import { ModalUpdateRelease } from '../../components';
import { APISchemaRelease, APISchemaChange, ChangelogChangeType } from '../../models/api';
import LoadingBar from "react-top-loading-bar";
import { Pagination } from '../../components';


export function ChangelogPage() {

    const [loaderProgress, setLoaderProgress] = useState(1);
    const [releaseModalShow, setReleaseModalShow] = useState(false);
    const [editType, setEditType] = useState(0);
    const [release, setRelease] = useState<APISchemaRelease | null>(null);

    const [pageIndex, setPageIndex] = useState(PaginationSettings.initialPageIndex);
    const [pageSize, setPageSize] = useState(PaginationSettings.initialPageSize);
    const [releasesCount, setReleasesCount] = useState<number>(10);

    const { onAddRelease, onUpdateRelease, onDeleteRelease, getReleasesCount } = useFunctionalityChangelog();

    const { releaseList, pagedListCount, pagedReleasesUrl } = useFunctionalityPagedChangelog({
        pageSize: pageSize,
        pageNo: pageIndex,
        setLoaderProgress,
    });


    // useEffect(() => {
    //     console.log("useEffect for getting releases fired");
    //     onGetReleases(setReleases);
    // }, []);

    //   useEffect(() => {
    //     console.log("useEffect for printing releases fired");
    //     console.log("releases:", releases);

    //   }, [releases])

    // useEffect(() => {
    //     console.log("releaseList is:", releaseList);
    // })

    useEffect(()=>{
        (async () => {
          const count = await getReleasesCount();
          if (count){ 
            // console.log("count is:", count);
            setReleasesCount(count);
        }
        })();
    
      }, [])
    

    const data = useAppSelector(
        (state: VRIAppStateType) => ({
            isLoggedIn: state.auth.isLoggedIn,
            role: state.auth.profile?.userRole,
            videoCallStatus: state.videoCall.CallStatus,
        }),
        shallowEqual
    );

    const { onLogout } = useFunctionalityAuth();
    const location = useLocation();


    useEffect(() => {
        if (location.pathname === "/changelog") {
            document.body.classList.add("no-bg");
        } else {
            document.body.classList.remove("no-bg");
        }
        return () => {
            document.body.classList.remove("no-bg");
        };
    }, [location.pathname]);

    return (
        <>

            <LoadingBar
                progress={loaderProgress}
                onLoaderFinished={() => setLoaderProgress(0)}
            />

            <Navbar style={{ backgroundColor: "var(--site-purple)" }} variant="dark" expand="lg" sticky="top">
                <Container>
                    <Navbar.Brand style={{ fontSize: "16px" }}>Gateway To Access</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">

                        <Nav className="ms-auto">
                            {data.isLoggedIn ? (
                                data.role === AppConstants.UserRoles.Operator ? (
                                    <Nav.Link as={Link} to="/call-log">Dashboard</Nav.Link>
                                ) : (
                                    <Nav.Link as={Link} to="/home">Dashboard</Nav.Link>
                                )
                            ) : <></>}


                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {loaderProgress ?
                (<>
                    <div className="d-flex align-items-center justify-content-center w-100 changelog-state">
                        <h1 className="changelog-state-text">
                            Loading...
                        </h1>

                    </div>

                </>)
                :
                Array.isArray(releaseList) ? (
                    <>

                        <div className="d-flex flex-column justify-content-center align-items-center w-100 changelog-page">


                            <div className="d-flex flex-column justify-content-center no-wrap mb-5 p-3 changelog-content">

                                <div className="d-inline-flex flex-row flex-wrap justify-content-between align-items-center mt-5 mb-4 changelog-header">
                                    <div><h1 className="changelog-title">Changelog</h1></div>

                                    {data.isLoggedIn && data.role === AppConstants.UserRoles.Admin ? (

                                        <button
                                            className="btn btn-primary d-flex align-items-center"
                                            onClick={() => {
                                                setReleaseModalShow(true);
                                            }}
                                        >
                                            <span className="flex-shrink-0 me-2">
                                                <span >
                                                    <AssetSvg.Plus />
                                                </span>
                                            </span>
                                            New Release
                                        </button>
                                    ) : (<></>)
                                    }
                                </div>
                                {releaseList.map((release: any, index: any) => (
                                    <>
                                        <ChangelogBox key={index} release={release} setRelease={setRelease} setReleaseModalShow={setReleaseModalShow} />
                                        {index < releaseList.length - 1 &&
                                            <div className="w-100 d-flex flex-column align-items-center justify-content-center changelog-timeline">
                                                <div className="changelog-timeline-dot"></div>
                                                <div className="changelog-timeline-line"></div>
                                                <div className="changelog-timeline-dot"></div>

                                            </div>}
                                    </>

                                ))}
                                <div className="pt-5">
                                    <Pagination
                                        pageSize={pageSize}
                                        pageIndex={pageIndex}
                                        count={releasesCount}
                                        onChangePageSize={setPageSize}
                                        onChangePageIndex={setPageIndex}
                                    />
                                </div>
                            </div>
                        </div>

                        <ModalUpdateRelease
                            show={releaseModalShow}
                            handleShow={setReleaseModalShow}
                            onAddRelease={onAddRelease}
                            onUpdateRelease={onUpdateRelease}
                            onDeleteRelease={onDeleteRelease}
                            release={release}
                            setRelease={setRelease}
                        />



                    </>) : (
                    <>
                        <div className="d-flex align-items-center justify-content-center w-100 changelog-state">
                            <h1 className="changelog-state-text">
                                No Data
                            </h1>

                        </div>

                    </>
                )

            }

        </>
    );

}
